var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileSearch02Duotone = function SvgFileSearch02Duotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28 22H16m4 8h-4m16-16H16m24 7v-7.4c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C35.44 4 33.76 4 30.4 4H17.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C8 8.56 8 10.24 8 13.6v20.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C12.56 44 14.24 44 17.6 44H23m21 0-3-3m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    d: "M36 43a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m44 44-3-3m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
  })));
};
export default SvgFileSearch02Duotone;